import styled from 'styled-components';
import { th } from 'style/theme';
import { sizes } from 'style';

export const ExclusionsBox = styled.div`
  padding: 16px 24px;
  border-radius: 8px;
  border: 1px solid ${th('colors.fuzzyWuzzyBrown')};
  background-color: ${th('colors.fuzzyWuzzyBrown+4')};

  @media ${sizes.desktop} {
    border-radius: 16px;
  }

  > a,
  > a:hover {
    color: ${th('colors.pickledBluewood')};
  }
`;

export const ExcludedDestinations = styled.div`
  display: grid;
  margin: 8px 0;

  @media ${sizes.tabletPortrait} {
    grid-template-columns: 1fr 1fr;
  }

  @media ${sizes.desktop} {
    grid-template-columns: 1fr 1fr 1fr;
  }
`;

export const Destination = styled.div`
  margin: 2px 0;
  > img {
    margin-right: 4px;
  }
`;
